import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE, timeout: 300000 });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function getHcdSnapshot({ force = false } = {}) {
  const { data } = await client.get('/monitoring/hcd', {
    params: force ? { force: 1 } : undefined,
  });
  return data;
}

/** Resumen compacto del HCD (sin descargar el snapshot completo ~MB).
 *  Devuelve null si todavía no hay snapshots persistidos. */
export async function getHcdSummary() {
  try {
    const { data } = await client.get('/monitoring/hcd-summary');
    return data;
  } catch (e) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

/** Q&A focalizado en datos del HCD San Nicolás. */
export async function askHcd(question) {
  const { data } = await client.post('/messaging/ask-hcd', { question });
  return data;
}

/** Lista de autoridades del HCD con perfiles (o fallback desde snapshot). */
export async function listHcdAuthorities() {
  const { data } = await client.get('/monitoring/hcd-authorities');
  return data;
}

/** Perfil detallado de una autoridad (cacheado en Neon). */
export async function getHcdAuthorityProfile(slug) {
  const { data } = await client.get(`/monitoring/hcd-authority/${encodeURIComponent(slug)}`);
  return data;
}

/** Fuerza regeneración del perfil (Google News + DeepSeek). Rate-limited. */
export async function regenerateHcdAuthorityProfile(slug) {
  const { data } = await client.post(`/monitoring/hcd-authority/${encodeURIComponent(slug)}`);
  return data;
}

/** Q&A sobre una autoridad usando su perfil persistido + opcional búsqueda en vivo. */
export async function askAuthority({ slug, question, history = [], freshSearch = false }) {
  const { data } = await client.post('/messaging/ask-authority', {
    slug,
    question,
    history,
    fresh_search: freshSearch,
  });
  return data;
}

/** Búsqueda híbrida (FTS + cosine) sobre los 27k chunks del HCD. */
export async function searchHcd({ query, topK = 12, types = null } = {}) {
  const { data } = await client.post('/monitoring/hcd-search', {
    query,
    top_k: topK,
    types,
  });
  return data;
}

const monitoringService = {
  getHcdSnapshot,
  getHcdSummary,
  askHcd,
  listHcdAuthorities,
  getHcdAuthorityProfile,
  regenerateHcdAuthorityProfile,
  askAuthority,
  searchHcd,
};
export default monitoringService;
